import * as Yup from "yup";

export const loginSchema = Yup.object().shape({
  username: Yup.string()
    .email("This is not a valid email*")
    .required("Email is required*"),
  password: Yup.string().required("Password is required*"),
});

export const forgetPasswordSchema = Yup.object().shape({
  email: Yup.string()
    .email("This is not a valid email*")
    .required("Email is required*"),
});

export const resetPasswordSchema = Yup.object().shape({
  otp: Yup.string().required("OTP is required*"),
  newPassword: Yup.string().required("New password is required*"),
});
